import { createSlice } from "@reduxjs/toolkit"

const selectNetworkModalSlice = createSlice({
  name: "selectNetworkModalState",
  initialState: {
    open: false,
    data: {
      title: "",
      subtitle: "",
      callback: () => {}
    }
  },
  reducers: {
    setSelectNetworkModalOpen: (state, action) => {
      state.open = action.payload
    },
    setSelectNetworkModalData: (state, action) => {
      state.data = action.payload
    }
  }
})

export const { setSelectNetworkModalOpen, setSelectNetworkModalData } =
  selectNetworkModalSlice.actions

export default selectNetworkModalSlice.reducer
